"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logWithTs = void 0;
function logWithTs(...optionalParams) {
    const params = [
        Date.now(),
    ];
    // Should locate last
    params.push(...optionalParams);
    // Output
    console.log(...params);
}
exports.logWithTs = logWithTs;
